import React, { useState } from 'react'
import { DialogControl, FieldControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';
import '../../screens/Dashboard.scss';
import { SystemTypes } from 'spark-core-dx/services';

const IconSelectorDialog = ({ isActive, closeDialog }) => {
	const { selectedTabData, iconSelectData, dashboardLib } = useDashboardDomainContext();
	const [currentIcon, setCurrentIcon] = useState(selectedTabData?.DraftDetails?.Icon || "");
	const [currentColumnCount, setCurrentColumnCount] = useState(selectedTabData?.DraftDetails?.ColumnCount || "");

	return (
		<DialogControl
			className="dashboard-dialog"
			openDialog={isActive}
			title="Edit Dashboard"
			okText="Save"
			onCancel={() => closeDialog()}
			onOk={async () =>  {
				// hand the chosen icon back up:
				await dashboardLib.handleDashSmallChange(currentIcon,currentColumnCount);
				closeDialog()
			}}
		>
			<div className="dialog-text">
				<FieldControl
					fieldMetadata={{
						FieldType: 25,
						DataJson: iconSelectData,
						DisplayName: "Please select an icon"
					}}
					value={currentIcon}
					onChange={setCurrentIcon}
				/>
				<FieldControl
					fieldMetadata={{
						FieldType: SystemTypes.UIFieldType.SearchSelectList,
						DataJson: [
						{ "Text": "1",  "Value": 1 },
						{ "Text": "2",  "Value": 2 },
						{ "Text": "3",  "Value": 3 },
						{ "Text": "4",  "Value": 4 },
						{ "Text": "5",  "Value": 5 },
						{ "Text": "6",  "Value": 6 },
						{ "Text": "7",  "Value": 7 },
						{ "Text": "8",  "Value": 8 },
						{ "Text": "9",  "Value": 9 },
						{ "Text": "10", "Value": 10 },
						{ "Text": "11", "Value": 11 },
						{ "Text": "12", "Value": 12 },
						{ "Text": "13", "Value": 13 },
						{ "Text": "14", "Value": 14 },
						{ "Text": "15", "Value": 15 }
						],
						DisplayName: "Please select the number of column you would like on the grid."
					}}
					value={currentColumnCount}
					onChange={setCurrentColumnCount}
				/>
			</div>
		</DialogControl>
	);
}

export default IconSelectorDialog;